import ImageWithBasePath from "@/components/image-with-base-path"
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CountUp from "react-countup";
import { Link } from "react-router";
import { all_routes } from "@/routes/all_routes";

const BannerSection = () => {
 const sliderRef = useRef<Slider | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false, // we’ll use custom external buttons
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // run once
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  return (
    <>
  {/* Home Banner */}
  <section ref={sectionRef} className="banner-section-fourteen">
    <Slider ref={sliderRef} {...settings} className="banner-slider-fourteen">
      <div className="banner-slide">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-lg-7 col-xl-6">
              <div
                className="banner-content wow fadeInUp"
                data-wow-delay="0.2s"
                data-wow-duration="1s"
              >
                <h1>
                  Skin that <span className="section-line">Glows</span> With{" "}
                  <span className="subtitle">Confidence</span>
                </h1>
                <p>
                  Expert dermatological care combining medical precision with a
                  deep understanding of how your skin affects how you feel.
                </p>
                <Link
                  to={all_routes.register}
                  className="btn btn-secondary theme-14-btn"
                >
                  <i className="isax isax-calendar-tick5 me-2" />
                  Schedule Visit Now
                </Link>
                <div className="banner-wrap">
                  <div className="banner-item-two">
                    <h2>
                      <span className="count-digit">{isVisible && (
                        <CountUp className="number" end={98} duration={2} />
                      )}</span>%
                    </h2>
                    <p className="mb-0">Customers Satisfaction</p>
                  </div>
                  <div className="banner-item-two">
                    <h2>
                      <span className="count-digit">{isVisible && (
                        <CountUp className="number" end={8} duration={2} />
                      )}</span>K+
                    </h2>
                    <p className="mb-0">Sessions Completed</p>
                  </div>
                  <div className="banner-item-two">
                    <h2>
                      <span className="count-digit">{isVisible && (
                        <CountUp className="number" end={40} duration={2} />
                      )}</span>+
                    </h2>
                    <p className="mb-0">Type of Services </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-xl-6">
              <div className="banner-img">
                <ImageWithBasePath
                  src="assets/img/banner/skin-banner-01.png"
                  className="img-fluid banner-image"
                  alt="banner"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="banner-slide">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-xl-6">
              <div
                className="banner-content wow fadeInUp"
                data-wow-delay="0.2s"
                data-wow-duration="1s"
              >
                <h1>
                  Reveal <span className="section-line">Natural</span> Radiant{" "}
                  <span className="subtitle">Skin</span>
                </h1>
                <p>
                  Personalized skincare solutions from certified dermatology
                  specialists for acne, pigmentation, aging, and more.
                </p>
                <Link
                  to={all_routes.register}
                  className="btn btn-secondary theme-14-btn"
                >
                  <i className="isax isax-calendar-tick5 me-2" />
                  Explore Services
                </Link>
                <div className="banner-wrap">
                  <div className="banner-item-two">
                    <h2>{isVisible && (
                        <CountUp className="number" end={95} duration={2} />
                      )}%</h2>
                    <p className="mb-0">Customers Satisfaction</p>
                  </div>
                  <div className="banner-item-two">
                    <h2>{isVisible && (
                        <CountUp className="number" end={8} duration={2} />
                      )}K+</h2>
                    <p className="mb-0">Sessions Completed</p>
                  </div>
                  <div className="banner-item-two">
                    <h2>{isVisible && (
                        <CountUp className="number" end={40} duration={2} />
                      )}+</h2>
                    <p className="mb-0">Type of Services </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div
                className="banner-img wow fadeInUp"
                data-wow-delay="0.2s"
                data-wow-duration="1s"
              >
                <ImageWithBasePath
                  src="assets/img/banner/skin-banner-02.png"
                  className="img-fluid banner-image"
                  alt="banner"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Slider>
    <div className="slide-btn">
      <button type="button" className="slick-arrow ban-prev" aria-label="Prev"         onClick={() => sliderRef.current?.slickPrev()}
>
        <i className="isax isax-arrow-left" />
      </button>
      <button type="button" className="slick-arrow ban-next" aria-label="Next" onClick={() => sliderRef.current?.slickNext()}>
        <i className="isax isax-arrow-right-1" />
      </button>
    </div>
    <ImageWithBasePath src="assets/img/bg/skin-bg-01.png" alt="bg" className="banner-bg-01" />
    <ImageWithBasePath src="assets/img/bg/skin-bg-02.png" alt="bg" className="banner-bg-02" />
  </section>
  {/* Home Banner End */}
</>

  )
}

export default BannerSection